<template>
  <!-- -->
  <fullscreen v-model="fullscreen">

  <div class="main-wrapper_class" ref="root">


    <!---
      ***********************************************************************************
      *******************************         Map Page    *******************************
      ***********************************************************************************
    --->
    <div class="map_class">
      <div class="home_logo_class" @click="logoClick">
        <img src="../assets/emobi/user/logo_button.png"/>
      </div>

      <div class="home_logo_long_class" @click="sightClick">
        <img v-if="filtered==FILTER_SIGHT" src="../assets/emobi/user/sight_select.png"/>
        <img v-else src="../assets/emobi/user/sight_normal.png"/>
      </div>

      <div class="home_logo_class" @click="foodClick">
        <img v-if="filtered==FILTER_FOOD" src="../assets/emobi/user/food_select.png"/>
        <img v-else src="../assets/emobi/user/food_normal.png"/>
      </div>

      <div class="home_logo_class" @click="localClick">
        <img v-if="filtered==FILTER_LOCAL" src="../assets/emobi/user/local_select.png"/>
        <img v-else src="../assets/emobi/user/local_normal.png"/>
      </div>

      <div class="home_logo_class" @click="otherClick">
        <img v-if="filtered==FILTER_OTHER" src="../assets/emobi/user/other_select.png"/>
        <img v-else src="../assets/emobi/user/other_normal.png"/>
      </div>

      <div class="home_logo_class" @click="carparkClick">
        <img v-if="filtered==FILTER_CARPARK" src="../assets/emobi/user/carpark_select.png"/>
        <img v-else src="../assets/emobi/user/carpark_normal.png"/>
      </div>

      <div class="home_logo_class" @click="favorClick">
        <img v-if="filtered==FILTER_FAVOR" src="../assets/emobi/user/favor_select.png"/>
        <img v-else src="../assets/emobi/user/favor_normal.png"/>
      </div>

      <div class="home_search_class" @click="searchClick">
        <img src="../assets/emobi/user/search_icon.png"/>
      </div>


    </div>



    <!---
      ***********************************************************************************
      *******************************     Content Page    *******************************
      ***********************************************************************************
        --->
    <div class="content_class">

      <div class="title_class" v-if="mode==4">
        {{hashtagTitle}}
      </div>

      <!--===============                   Mode 1            =================-->
      <table class="table_class" v-if="mode==1">
        <tbody>
        <tr v-for="sight in sightInfo" v-bind:key="sight.id" @click="listClick(sight)">

          <td class="table_icon_class">
            <img v-bind:src="sight.url" style="width:40px; height:40px" alt="">
          </td>

          <td class="table_content_class">
              {{sight.name}}
            <p>{{sight.content}}</p>
          </td>

          <td class="table_sales_class">
            <img v-bind:src="sight.url_sales" style="width:50px; height:50px; margin:10px" alt="" v-if="sight.sales==1">
          </td>

        </tr>
        </tbody>
        <!--      -->
      </table>

      <!--===============                   Mode 2            =================-->
      <div class="detail_class" v-if="mode==2">

        <div class="detail_header_class">
          <img class="detail_header_icon_class" :src="detail_icon"/>
          <div class="detail_header_text_class">{{detail_title}}</div>
          <img class="detail_header_icon_class" src="../assets/emobi/user/sales.png" v-if="sight_sales==1"/>
        </div>

        <div class="detail_content_class">

          <img class="detail_header_photo_class" :src="sight_photo"/>

          <div class="detail_content_subject_class">說明</div>
          <div class="detail_content_text_class">{{detail_desc1}}</div>

          <div class="detail_content_row_class">
            <div class="detail_content_row_subject_class">営業時間:</div>
            <div class="detail_content_row_text_class">{{detail_desc2}}</div>
          </div>

          <div class="detail_content_row_class">
            <div class="detail_content_row_subject_class">定休日:</div>
            <div class="detail_content_row_text_class">{{detail_desc3}}</div>
          </div>

          <div class="detail_content_row_class">
            <div class="detail_content_row_subject_class">駐車場:</div>
            <div class="detail_content_row_text_class">{{detail_desc4}}</div>
          </div>

          <div class="detail_content_subject_class">お得情報</div>
          <div class="detail_content_text_class">{{detail_desc5}}</div>

          <div class="detail_content_hashtag_class">{{ detail_hashtag }}</div>

        </div>

        <div class="detail_bottom_class">
            <img class="detail_button_class" src="../assets/emobi/user/close_button.png" @click="clickBack"/>
            <img class="detail_button_class" src="../assets/emobi/user/select_button.png" @click="clickSelect" v-if="sight_selected==0"/>
            <img class="detail_button_class" src="../assets/emobi/user/select_button_orange.png" @click="clickSelect" v-if="sight_selected==1"/>
        </div>

      </div>

      <!--===============                   Mode 3            =================-->
      <table class="hashtag_table_class" v-if="mode==3">
        <tbody>
        <tr v-for="hashtag in hashtagList" v-bind:key="hashtag.id" @click="hashtagClick(hashtag)">

          <td width="60%">
            {{hashtag.name}}
          </td>

        </tr>
        </tbody>
        <!--      -->
      </table>


      <!--===============                   Mode 4            =================-->
      <table class="table_class" v-if="mode==4">
        <tbody>
        <tr v-for="sight in sightInfo" v-bind:key="sight.id" @click="listClick(sight)">

          <td class="table_icon_class">
            <img v-bind:src="sight.url" style="width:40px; height:40px" alt="">
          </td>

          <td class="table_content_class">
            {{sight.name}}
            <p>{{sight.content}}</p>
          </td>

          <td class="table_sales_class">
            <img v-bind:src="sight.url_sales" style="width:50px; height:50px; margin:10px" alt="" v-if="sight.sales==1">
          </td>

        </tr>
        </tbody>
        <!--      -->
      </table>



    </div>








  </div>
<!-- -->
  </fullscreen>

</template>





<script>

//https://github.com/mirari/vue-fullscreen
// npm install vue-fullscreen
import Vue from "vue";
import VueFullscreen from 'vue-fullscreen';
Vue.use(VueFullscreen)

import { wgs84togcj02 } from "coordtransform";
import moment from "moment";




import { w3cwebsocket } from "websocket";

import { imgs, mapMarker, carUp, carDown, WSURL, BroadcastUrl } from "../utils/indexNara2";
import {route, station, station_point, station_name, stop_pos} from "../utils/routeUR";

let { sign, auto, manual, start, stop, right, left } = imgs;




export default {
  name: "app",

  components: {
    //Gear,
    //Battery,
    //Road,
    //Popup,
  },



  // ********************************************************************************************
  // ***************************                  Data           ********************************
  // ********************************************************************************************
  data() {
    return {

      eMobiStatus:0,
      eMobiID: 4,     // debug


      fullscreen: false,
      //websocket实例
      client: null,
      BroadClient: null,
      map: null,
      truemap: null,
      DEFAULT_LAT: 35.3252286420539,
      DEFAULT_LONG: 139.556017475308,
      DEFAULT_ZOOM: 14,
      loc_lat: this.DEFAULT_LAT,
      loc_long: this.DEFAULT_LONG,
      map_zoom: this.DEFAULT_ZOOM,

      markers:[],         // sight, food, other
      marker: null,       // 小车标注

      mode:1,
      detail_icon:"",
      detail_title:"",
      detail_desc1:"",
      detail_desc2:"",
      detail_desc3:"",
      detail_desc4:"",
      detail_desc5:"",
      detail_hashtag:"",

      hashtagTitle:"",
      hashtag1:"",
      hashtag2:"",
      hashtag3:"",
      hashtag4:"",
      hashtag5:"",
      hashtag6:"",

      sight_highlight:99999,
      sight_selected:0,
      sight_sales:0,
      sight_photo:"",
/*
      SIGHT_TYPE: 0,
      SIGHT_SUBTYPE: 1,
      SIGHT_TRIPTYPE: 2,
      SIGHT_NAME: 3,
      SIGHT_LAT: 4,
      SIGHT_LONG: 5,
      SIGHT_DESC0: 6,
      SIGHT_DESC1: 7,
      SIGHT_DESC2: 8,
      SIGHT_DESC3: 9,
      SIGHT_DESC4: 10,
      SIGHT_DESC5: 11,
      SIGHT_SALES: 12,
      SIGHT_SELECTED: 13,
      SIGHT_PHOTO: 14,
*/
      DUMMY_ID: 9999999,
      SIGHT_HIGHLIGHT_NULL: 99999,

      SIGHT_TYPE_SIGHT: 0,
      SIGHT_TYPE_FOOD: 1,
      SIGHT_TYPE_LOCAL: 2,
      SIGHT_TYPE_OTHER: 3,
      SIGHT_TYPE_CARPARK: 4,
      SIGHT_TYPE_FAVOR: 5,

      SIGHT_SUBTYPE_NORMAL: 0,
      SIGHT_SUBTYPE_TEMPLE: 1,
      SIGHT_SUBTYPE_NATURE: 2,
      SIGHT_SUBTYPE_EXP: 3,

      FILTER_NULL: 0,
      FILTER_SIGHT: 1,
      FILTER_FOOD: 2,
      FILTER_LOCAL: 3,
      FILTER_OTHER: 4,
      FILTER_CARPARK: 5,
      FILTER_FAVOR: 6,
      FILTER_HASHTAG: 7,
      filterHasgtag: 0,

      filtered: 0,

      sightInfoTotalNum: 0,
      sightInfoCurrentNum: 0,
      S3PATH: "https://mopimanager.s3.ap-northeast-1.amazonaws.com/",

      sight_info: [
          /*
        [0, 0, 0, '鶴岡八幡宮', 35.3252286420539, 139.556017475308, '鶴岡八鬥宮與倉倉幕府一起開始，一直關注和支援倉倉的發展', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 0, 0, '長谷寺',    35.3126833514217, 139.533074126913, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 0, 0, '鎌倉大仏',  35.31679142165581, 139.53618010010533, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 1, 0, '建長寺',    35.331211241903084,139.55509125261125, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 1, 1, '円覚寺',    35.33808674737613, 139.54824931490683, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 1, 1, '瑞泉寺',    35.32727224265797, 139.57521545310155, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 2, 1, '稲村ヶ崎',   35.30304370907807, 139.52681332276921, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [0, 2, 1, '鎌倉高校前踏切',35.30665419327026, 139.50209976382396, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
        [1, 0, 2, '材木座テラス', 35.30820810668993, 139.5479940578568, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 1, 0, "sight1.jpg"],
        [1, 0, 2, 'カフェ ヨリドコロ', 35.305404428597434,139.52695917376542, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 1, 0, "sight1.jpg"],
        [2, 0, 2, '3時のおやつ工房', 35.31643343166013, 139.5629356319186, 'xxxxxxxx', '始まりは、鎌倉幕府を築いた源頼朝公の祖先源頼義が、京都の石清水八幡宮を勧請(神様の御分霊を他の地に還し祀ること)したことです。', '6時~21時', 'なし', '有', 'TUKTUKのキーを見せると、茶寮風の杜で10%OFF', 0, 0, "sight1.jpg"],
           */
      ],

      sightStructure: [
        {
          "id": "1",
          "name": "",
          "type": 0,
          "selected": 0,
          "content": "",
          "url": "",
          "url_sales": "",
          "desc1": "",
          "desc2": "",
          "desc3": "",
          "desc4": "",
          "desc5": "",
          "sales": 0,
          "sight_photo":"",
        },
      ],

      sightInfo: [
        {
          "id": "1",
          "name": "",
          "type": 0,
          "selected": 0,
          "content": "",
          "url": require('../assets/publicroad/uparrow.png'),
          "url_sales": require('../assets/publicroad/uparrow.png'),
          "desc1": "",
          "desc2": "",
          "desc3": "",
          "desc4": "",
          "desc5": "",
        },
      ],

      hashtagList: [
          /*
        { "id": "1", "name": "1234"},
        { "id": "2", "name": this.hashtag2},
        { "id": "3", "name": this.hashtag3},
        { "id": "4", "name": this.hashtag4},
        { "id": "5", "name": this.hashtag5},
        { "id": "6", "name": this.hashtag6},
        */
      ],












      //小车车速、电量以及挡位情况
      carInfo: {
        speed: 50,
        batteryLevel: 1,
        gearPosition: "P"
      },

      //当前时间
      time: "",
      //障碍物
      obstacles: [],
      //左转、右转等标志
      signSrc: sign[4],
      //自动/手动驾驶
      isAuto: false,
      timer: null,
      isTempStart: true,
      tempSrc: stop,
      //下一站点信息
      station: {
        name: "",
        time: ""
      },
      //转弯
      isTurn: false,
      turnSrc: "",
      //重连timer
      reconnectionTimer: null,
      roadHeight: 0,
      roadWidth: 0,
      //是否展示弹窗
      visible: false,
      stationName: "",
      stationTime: "",
      stationUrl: "",
      //是否展示关机弹窗
      visibleClose: false,
      moduleReboot: false,
      //display connecting info
      websocketConnecting: false,

      //方向盘转换角度
      rotate: 0,


      // ----- Public Road -----
      //底层按钮操作相关变量
      isStart: false,
      isStop: false,    // in STOP sign
      isGo: false,       // Direction Go (top to bottom) or Back (bottom to top)
      current_station_name: "Bus stop 1",
      //next_station_name: "復元事業情報館",
      next_station_name: "Bus stop 1",
      route_point: 0,
      map_route_point: 9000,
      loc_heading: 0,
      veh_speed: 29,
      loc_polyline: null, // route
      station_margin: 0.00015,
      heading_margin: 0.3,
      station_point_margin: 20,

      MAXSTATION: 165,

      sample_interval: 1000,

      systemState: 0,
      cueSize: 0,
      objcue: [
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
      ],

      target_heading_lower: [
        330,      // reset start
        330,      // 1  0 +/- 30
        150,      // 2  180 +/- 30
        105,      // 3  135 +/-30
        230,    // 4 270-40     //185,      // 4  225 +/- 40
        330,      // 5  0 +/- 30
      ],
      target_heading_upper: [
        30,       // reset start
        30,       // 1  0 +/- 30
        210,      // 2  180 +/- 30
        165,      // 3  135 +/-30
        310,    // 4 270+40            //265,      // 4  225 +/- 40
        30,       // 5  0 +/- 30
      ],


      // https://vuejsexamples.com/a-vue-component-of-dynamic-table/
      params: {
        data: [
          ['連番', '乗車日時'],
          ['連番', '乗車日時'],
          ["../assets/vehicle/colorlogo.png", '乗車日時'],
        ],
        //header: 'row',
        border: false,
        showCheck: false,
        columnWidth: [{column: 0, width: '30%'}, {column: 1, width: '70%'}],
        height: 500,
        rowHeight:100,
      },




    };
  },



  // ********************************************************************************************
  // ***************************                  Computed       ********************************
  // ********************************************************************************************
  computed: {
  },

  // ********************************************************************************************
  // ***************************                  Created        ********************************
  // ********************************************************************************************
  created() {

    console.log(" ***** Creatrd *****");

    //this.updateTime();
    //this.createWS();
    this.createBroadcast();
  },


  // ********************************************************************************************
  // ***************************                  Mounted        ********************************
  // ********************************************************************************************
  mounted() {

    console.log(" ***** Mounted *****");

    // ----- Default Value -----
    this.refresh_list();
    this.loc_lat = this.DEFAULT_LAT;
    this.loc_long= this.DEFAULT_LONG;
    this.map_zoom= this.DEFAULT_ZOOM;
    this.sight_highlight = this.SIGHT_HIGHLIGHT_NULL;

    // ----- Init View -----
    this.initMap();
    this.resetDrawCar([this.loc_lat, this.loc_long]);
    this.drawMarker();

    this.get_sight_center();
    if(!("geolocation" in navigator))
    {
      console.log("Geolocation NOT supported");
    }
    else
    {
      this.gps_timer();
    }
  },






  methods: {

    // ********************************************************************************************
    // ***************************              Map   Code         ********************************
    // ********************************************************************************************

    //初始化地图
    initMap() {

      let normalMap = this.L.tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }
      );

      this.truemap = document.querySelector(".map_class");
      console.log("Width : " + this.truemap.clientWidth + " Height : " + this.truemap.clientHeight);
      console.log("Zoom Level: " +this.map_zoom);

      this.map = this.L.map(document.querySelector(".map_class"), {
        zoom: this.map_zoom,
        //zoom: 14,
        center: [this.loc_lat, this.loc_long],
        layers: [normalMap],
        preferCanvas: true,
        zoomControl: false,
      });

      //删除LeafLet右下角logo
      document.querySelector(".leaflet-control-attribution").style.display = "none";

      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 500);
    },


    reset_map()
    {
      if (this.map) {
        this.map.remove();
        this.map = null;
        //this.marker = null;
      }

      this.initMap();
    },


    resetDrawCar(position)
    {
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker=null
      }

      this.marker = this.drawCar(position);
    },

    //更新车辆位置
    updateCarPosition(position)
    {
      this.marker.slideTo(position, {
        duration: 20,
        rotationOrigin: "center center"
      });
    },


    drawCar(point)
    {
      let icon = this.L.icon({
        iconUrl: require('../assets/emobi/user/dudu_icon.png'),
        iconSize: [28, 50]
      });
      return this.L.marker(point, {
        icon,
        zIndexOffset: 100,
        rotationOrigin: "center center"
      }).addTo(this.map);
    },


    clearMarker()
    {
      //console.log("Clear Markers:" + this.markers.length);

      let i;
      let ori_length =this.markers.length;
      for (i=0; i<ori_length; i++)
      {
        //console.log("Clear Markers i:" + (ori_length-1-i));

        this.map.removeLayer(this.markers[ori_length-1-i]);
        this.markers.pop();
      }
    },

    //根据标注点位画标注
    drawMarker()
    {
      this.clearMarker();

      // Icon options
      let iconOptions = {
        iconUrl: require('../assets/publicroad/dot.png'),
        iconSize: [40, 40],
      }
      // Creating a custom icon
      let customIcon = this.L.icon(iconOptions);
      // Creating Marker Options
      let markerOptions = {
        title: "Test",
        clickable: true,
        draggable: false,
        icon: customIcon
      }
      // Creating a Marker
      let marker;// = this.L.marker([marker_lat, marker_long], markerOptions);
      // Adding popup to the marker
      //marker.bindPopup("Test1").openPopup();

      let i;
      for (i=0; i<this.sightInfo.length; i++)
      {
        if (this.sightInfo[i].type == this.SIGHT_TYPE_SIGHT)
        {
          if (this.sightInfo[i].subtype == this.SIGHT_SUBTYPE_NORMAL)
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/sight_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/sight_pin.png');
          }
          else if (this.sightInfo[i].subtype == this.SIGHT_SUBTYPE_TEMPLE)
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/temple_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/temple_pin.png');
          }
          else if (this.sightInfo[i].subtype == this.SIGHT_SUBTYPE_NATURE)
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/nature_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/nature_pin.png');
          }
          else if (this.sightInfo[i].subtype == this.SIGHT_SUBTYPE_EXP)
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/exp_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/exp_pin.png');
          }
        }
        else if (this.sightInfo[i].type == this.SIGHT_TYPE_FOOD)
        {
          if (this.sightInfo[i].selected == 1)
            iconOptions.iconUrl = require('../assets/emobi/user/food_pin_selected.png');
          else
            iconOptions.iconUrl = require('../assets/emobi/user/food_pin.png');
        }
        else if (this.sightInfo[i].type == this.SIGHT_TYPE_LOCAL)
        {
          if (this.sightInfo[i].selected == 1)
            iconOptions.iconUrl = require('../assets/emobi/user/local_pin_selected.png');
          else
            iconOptions.iconUrl = require('../assets/emobi/user/local_pin.png');
        }
        else if (this.sightInfo[i].type == this.SIGHT_TYPE_OTHER)
        {
          if (this.sightInfo[i].selected == 1)
            iconOptions.iconUrl = require('../assets/emobi/user/other_pin_selected.png');
          else
            iconOptions.iconUrl = require('../assets/emobi/user/other_pin.png');
        }
        else if (this.sightInfo[i].type == this.SIGHT_TYPE_CARPARK)
        {
          if (this.sight_info[i].freepark == 0)
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/carpark_pay_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/carpark_pay_pin.png');
          }
          else
          {
            if (this.sightInfo[i].selected == 1)
              iconOptions.iconUrl = require('../assets/emobi/user/carpark_free_pin_selected.png');
            else
              iconOptions.iconUrl = require('../assets/emobi/user/carpark_free_pin.png');
          }

        }

        //console.log("Highlight: " + this.sight_highlight);
        if (this.sightInfo[i].id==this.sight_highlight)
          iconOptions.iconSize = [80, 99];
        else
          iconOptions.iconSize = [40, 56];

        customIcon = this.L.icon(iconOptions);

        markerOptions.title = this.sightInfo[i].name;
        markerOptions.icon = customIcon;

        marker = this.L.marker([this.sightInfo[i].lat, this.sightInfo[i].long], markerOptions).addTo(this.map);
        //marker = this.L.marker([this.loc_lat, this.loc_long], markerOptions);
        //marker.bindPopup(this.sightInfo[i].name).openPopup();

        // Adding marker to the map
        this.markers.push(marker);
        //console.log("Maker: " + this.markers.length + " " + this.sightInfo[i].id);
        //let j = this.sightInfo[i].id;
        let j = i;
        this.markers[this.markers.length-1].addEventListener("click", () => { this.markerClick(j) });
      }

      //console.log("Add Markers:" + this.markers.length);
    },



    markerClick(i)
    {
      //console.log("Click: " + i);
      this.listClick(this.sightInfo[i]);
    },

    gps_timer()
    {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        navigator.geolocation.getCurrentPosition(pos => {
          //console.log("Geolocation: " + pos);
          //console.log("Geolocation: " + pos.coords.latitude + " " + pos.coords.longitude);
          this.loc_lat = pos.coords.latitude;
          this.loc_long=pos.coords.longitude;
          this.resetDrawCar([this.loc_lat, this.loc_long]);

          //this.map.flyTo([this.loc_lat, this.loc_long],14);
          //Cur  this.map.panTo([this.loc_lat, this.loc_long],14);
          //this.map.setView([this.loc_lat, this.loc_long],14);

          this.BroadcastSend(
              JSON.stringify({
                type: "eMobiUploadGPS",
                status: this.eMobiStatus,
                vehicleID: this.eMobiID,
                latitude: this.loc_lat,
                longitude: this.loc_long
              })
          );


        }, err => {
          console.log("Geolocation Error: " + err.message);
        })
      }, 10000);
    },















    drawRoute()
    {
      //if (this.route_point == this.map_route_point)
      //  return;
      //this.map_route_point = this.route_point;

      let i;
      let points = [];
      for (i = 0; i<route.length; i++){    // from start or route points
        points.push(route[i]);
        //console.log("Points : " + points[i]);
      }

      // ---------- Draw Route Line ---------
      if (this.loc_polyline!=null){
        this.map.removeLayer(this.loc_polyline);
      }

      {
        this.loc_polyline = this.L.polyline(points, {
          color: "#13b49b",
          weight: 6
        }).addTo(this.map);
      }

      // ---------- Update Car Marker ---------
      let position= [this.loc_lat, this.loc_long];
      let heading= this.loc_heading;
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }// else
      {
        this.marker = this.drawCar(position);
      }

    },









    // ********************************************************************************************
    // ***************************              Data   Code         ********************************
    // ********************************************************************************************

    logoClick()
    {
//      if (this.fullscreen==true)
//        this.fullscreen = !this.fullscreen
      //this.fullscreen = !this.fullscreen
      this.fullscreen = true
      this.reset_map();

      // debug use
      //console.log("Sight length:" + this.sightInfo.length);
      //this.filtered = this.FILTER_NULL;

      // debug
      //console.log("** Master List: " + this.sight_info)
      //this.requestSight(0)

      this.filtered = this.FILTER_NULL;
      this.mode=1;
      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();
    },

    sightClick()
    {
      if (this.filtered == this.FILTER_SIGHT)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_SIGHT;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },

    foodClick()
    {
      if (this.filtered == this.FILTER_FOOD)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_FOOD;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },

    localClick()
    {
      if (this.filtered == this.FILTER_LOCAL)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_LOCAL;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },

    otherClick()
    {
      if (this.filtered == this.FILTER_OTHER)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_OTHER;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },

    carparkClick()
    {
      if (this.filtered == this.FILTER_CARPARK)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_CARPARK;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },


    favorClick()
    {
      if (this.filtered == this.FILTER_FAVOR)
        this.filtered = this.FILTER_NULL;
      else
      {
        this.mode=1;
        this.filtered = this.FILTER_FAVOR;
      }

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();

      if (this.mode==1)
        this.get_sight_center()
    },

    searchClick()
    {
      this.filtered = this.FILTER_NULL;
      if (this.mode!=3)
      {
        this.createHashTagList()
        this.mode=3;
      }
      else
      {
        this.mode=1;
        this.refresh_list();
        this.resetDrawCar([this.loc_lat, this.loc_long]);
        this.drawMarker();
        this.get_sight_center()
      }

    },

    hashtagClick(record)
    {
      //console.log("Click: " +record.id)

      this.mode=4;
      this.hashtagTitle = record.name;
      this.filtered = this.FILTER_HASHTAG;
      this.filterHasgtag = record.id;

      this.refresh_list();
      this.resetDrawCar([this.loc_lat, this.loc_long]);
      this.drawMarker();
      this.get_sight_center()
    },



    createHashTagList()
    {
      while(this.hashtagList.length!=0)
        this.hashtagList.pop()

      this.hashtagList.push({"id": 1, "name": '#'+this.hashtag1})
      this.hashtagList.push({"id": 2, "name": '#'+this.hashtag2})
      this.hashtagList.push({"id": 3, "name": '#'+this.hashtag3})
      this.hashtagList.push({"id": 4, "name": '#'+this.hashtag4})
      this.hashtagList.push({"id": 5, "name": '#'+this.hashtag5})
      this.hashtagList.push({"id": 6, "name": '#'+this.hashtag6})

    },



    listClick(record)
    {
      console.log("List Click: " + record.id);//:" + i + "  Name: " + newSight.Name);

      if (record.id == this.DUMMY_ID)
        return;

      this.mode=2;

      console.log(record.hashtag2)

      this.detail_icon =  record.url;
      this.detail_title = record.name;

      this.detail_desc1 = record.desc1;
      this.detail_desc2 = record.desc2;
      this.detail_desc3 = record.desc3;
      this.detail_desc4 = record.desc4;
      this.detail_desc5 = record.desc5;

      this.sight_highlight = record.id;
      this.sight_selected = record.selected;
      this.sight_sales = record.sales;
      //this.sight_photo = require('../assets/emobi/user/'+ record.sight_photo);
      //this.sight_photo = "https://mopimanager.s3.ap-northeast-1.amazonaws.com/sight1.jpg";
      this.sight_photo = record.sight_photo;


      this.detail_hashtag = ""
      if (record.hashtag1 ==1)
        this.detail_hashtag += ("#" + this.hashtag1 + "   ")
      if (record.hashtag2 ==1)
        this.detail_hashtag += ("#" + this.hashtag2+ "   ")
      if (record.hashtag3 ==1)
        this.detail_hashtag += ("#" + this.hashtag3 + "   ")
      if (record.hashtag4 ==1)
        this.detail_hashtag += ("#" + this.hashtag4 + "   ")
      if (record.hashtag5 ==1)
        this.detail_hashtag += ("#" + this.hashtag5 + "   ")
      if (record.hashtag6 ==1)
        this.detail_hashtag += ("#" + this.hashtag6 + "   ")

      this.map.panTo([record.lat, record.long],14);
      this.drawMarker();
    },

    clickBack()
    {
      this.sight_highlight = this.SIGHT_HIGHLIGHT_NULL;
      this.drawMarker();

      if (this.filtered == this.FILTER_HASHTAG)
        this.mode=4;
      else
        this.mode=1;
    },

    clickSelect()
    {
      if (this.sight_info[this.sight_highlight].selected==0)
      {
        this.sight_info[this.sight_highlight].selected=1;
        this.sight_selected =1;
      }
      else
      {
        this.sight_info[this.sight_highlight].selected=0;
        this.sight_selected =0;
      }
      this.refresh_list();
      this.drawMarker();
    },



    clear_master_sight_list()
    {
      while(this.sight_info.length!=0)
      {
        this.sight_info.pop();
      }
    },

    add_master_sight_list(sightArray)
    {
      console.log("** Add Master: " + sightArray + "  "+sightArray[3]+ "  "+sightArray[11]);

      var newSight ={
        "type": 0,
        "subtype": 0,
        "freepark": 0,
        "hashtag1": 0,
        "hashtag2": 0,
        "hashtag3": 0,
        "hashtag4": 0,
        "hashtag5": 0,
        "hashtag6": 0,
        "name": "test",
        "lat": 0,
        "long":0,
        "content": "",
        "desc1": "",
        "desc2": "",
        "desc3": "",
        "desc4": "",
        "desc5": "",
        "sales": 0,
        "selected": 0,
        "sight_photo":"",
      }
      newSight.type = parseInt(sightArray[0]);
      newSight.subtype = parseInt(sightArray[1]);
      newSight.freepark = parseInt(sightArray[2]);

      newSight.hashtag1 = parseInt(sightArray[3]);
      newSight.hashtag2 = parseInt(sightArray[4]);
      newSight.hashtag3 = parseInt(sightArray[5]);
      newSight.hashtag4 = parseInt(sightArray[6]);
      newSight.hashtag5 = parseInt(sightArray[7]);
      newSight.hashtag6 = parseInt(sightArray[8]);

      newSight.name = sightArray[9];
      newSight.lat = parseFloat(sightArray[10]);
      newSight.long = parseFloat(sightArray[11]);

      newSight.content = sightArray[12];
      newSight.desc1 = sightArray[13];
      newSight.desc2 = sightArray[14];
      newSight.desc3 = sightArray[15];
      newSight.desc4 = sightArray[16];
      newSight.desc5 = sightArray[17];
      newSight.sales = parseInt(sightArray[18]);
      newSight.selected = 0;    //parseInt(sightArray[19]);
      newSight.sight_photo = this.S3PATH + sightArray[20];

      this.sight_info.push(newSight);
    },


    refresh_list()
    {
      if (this.sightInfo.length>0)
        this.clear_list()
      this.create_list()
    },

    clear_list()
    {
      while(this.sightInfo.length!=0)
      {
        this.sightInfo.pop();
      }
    },

    create_list()
    {
      let i;
      let curHashtag;
      for (i=0; i<this.sight_info.length; i++)
      {
        var newSight ={
          "id": "1",
          "type": 0,
          "subtype": 0,
          "freepark": 0,
          "hashtag1": 0,
          "hashtag2": 0,
          "hashtag3": 0,
          "hashtag4": 0,
          "hashtag5": 0,
          "hashtag6": 0,
          "name": "",
          "lat": 0,
          "long":0,
          "content": "",
          "url": "",
          "url_sales": "",
          "desc1": "",
          "desc2": "",
          "desc3": "",
          "desc4": "",
          "desc5": "",
          "sales": 0,
          "selected": 0,
          "sight_photo":"",
        }

        if (this.filterHasgtag == 1)
          curHashtag = this.sight_info[i].hashtag1
        else if (this.filterHasgtag == 2)
          curHashtag = this.sight_info[i].hashtag2
        else if (this.filterHasgtag == 3)
          curHashtag = this.sight_info[i].hashtag3
        else if (this.filterHasgtag == 4)
          curHashtag = this.sight_info[i].hashtag4
        else if (this.filterHasgtag == 5)
          curHashtag = this.sight_info[i].hashtag5
        else if (this.filterHasgtag == 6)
          curHashtag = this.sight_info[i].hashtag6

        if ((this.filtered==this.FILTER_NULL) ||
            ((this.filtered==this.FILTER_SIGHT) && (this.sight_info[i].type==this.SIGHT_TYPE_SIGHT)) ||
            ((this.filtered==this.FILTER_FOOD) && (this.sight_info[i].type==this.SIGHT_TYPE_FOOD)) ||
            ((this.filtered==this.FILTER_LOCAL) && (this.sight_info[i].type==this.SIGHT_TYPE_LOCAL)) ||
            ((this.filtered==this.FILTER_OTHER) && (this.sight_info[i].type==this.SIGHT_TYPE_OTHER)) ||
            ((this.filtered==this.FILTER_CARPARK) && (this.sight_info[i].type==this.SIGHT_TYPE_CARPARK)) ||
            ((this.filtered==this.FILTER_FAVOR) && (this.sight_info[i].selected==1)) ||
            ((this.filtered==this.FILTER_HASHTAG) && (curHashtag==1)))
        {
          console.log("Sight list chossen: " + i)

          newSight.id = i;
          newSight.type = this.sight_info[i].type;
          newSight.subtype = this.sight_info[i].subtype;
          newSight.freepark = this.sight_info[i].freepark;
          newSight.hashtag1 = this.sight_info[i].hashtag1;
          newSight.hashtag2 = this.sight_info[i].hashtag2;
          newSight.hashtag3 = this.sight_info[i].hashtag3;
          newSight.hashtag4 = this.sight_info[i].hashtag4;
          newSight.hashtag5 = this.sight_info[i].hashtag5;
          newSight.hashtag6 = this.sight_info[i].hashtag6;

          newSight.lat = this.sight_info[i].lat;
          newSight.long = this.sight_info[i].long;

          newSight.name = this.sight_info[i].name;
          newSight.content = this.sight_info[i].content;
          newSight.desc1 = this.sight_info[i].desc1;
          newSight.desc2 = this.sight_info[i].desc2;
          newSight.desc3 = this.sight_info[i].desc3;
          newSight.desc4 = this.sight_info[i].desc4;
          newSight.desc5 = this.sight_info[i].desc5;
          newSight.sales = this.sight_info[i].sales;
          newSight.selected = this.sight_info[i].selected;
          newSight.sight_photo =this.sight_info[i].sight_photo;

          if (this.sight_info[i].type == this.SIGHT_TYPE_SIGHT)
          {
            if (this.sight_info[i].subtype == this.SIGHT_SUBTYPE_NORMAL)
              newSight.url = require('../assets/emobi/user/sight_icon.png');
            else if (this.sight_info[i].subtype == this.SIGHT_SUBTYPE_TEMPLE)
              newSight.url = require('../assets/emobi/user/temple_icon.png');
            else if (this.sight_info[i].subtype == this.SIGHT_SUBTYPE_NATURE)
              newSight.url = require('../assets/emobi/user/nature_icon.png');
            else if (this.sight_info[i].subtype == this.SIGHT_SUBTYPE_EXP)
              newSight.url = require('../assets/emobi/user/exp_icon.png');
          }
          else if (this.sight_info[i].type == this.SIGHT_TYPE_FOOD)
            newSight.url = require('../assets/emobi/user/food_icon.png');
          else if (this.sight_info[i].type == this.SIGHT_TYPE_LOCAL)
            newSight.url = require('../assets/emobi/user/local_icon.png');
          else if (this.sight_info[i].type == this.SIGHT_TYPE_OTHER)
            newSight.url = require('../assets/emobi/user/other_icon.png');
          else if (this.sight_info[i].type == this.SIGHT_TYPE_CARPARK)
          {
            if (this.sight_info[i].freepark == 0)
              newSight.url = require('../assets/emobi/user/carpark_pay_icon.png');
            else
              newSight.url = require('../assets/emobi/user/carpark_free_icon.png');
          }
          newSight.url_sales = require('../assets/emobi/user/sales.png');    // debug

          this.sightInfo.push(newSight);
        }
      }

      this.chkDummyList()
    },



    chkDummyList()
    {
      if (this.sightInfo.length==0)
      {
        var dummySight ={
          "id": this.DUMMY_ID,
          "type": 0,
          "subtype": 0,
          "freepark": 0,
          "hashtag1": 0,
          "hashtag2": 0,
          "hashtag3": 0,
          "hashtag4": 0,
          "hashtag5": 0,
          "hashtag6": 0,
          "name": "",
          "lat": 0,
          "long":0,
          "content": "",
          "url": "",
          "url_sales": "",
          "desc1": "",
          "desc2": "",
          "desc3": "",
          "desc4": "",
          "desc5": "",
          "sales": 0,
          "selected": 0,
          "sight_photo":"",
        }
        dummySight.url = require('../assets/emobi/user/dummy.png');
        this.sightInfo.push(dummySight);
      }
    },


    get_sight_center()
    {
      let i;
      let min_lat, max_lat;
      let min_long, max_long;


      this.loc_lat = this.DEFAULT_LAT;
      this.loc_long = this.DEFAULT_LONG;
      this.map_zoom = this.DEFAULT_ZOOM;

      console.log("Ori Lat: "+this.loc_lat + "   Long: "+this.loc_long)

      min_lat =  this.DEFAULT_LAT;
      max_lat =  this.DEFAULT_LAT;
      min_long =  this.DEFAULT_LONG;
      max_long =  this.DEFAULT_LONG;

      for (i=0;i<this.sightInfo.length;i++)
      {
        if (this.sightInfo[i].lat > max_lat)
          max_lat = this.sightInfo[i].lat;
        if (this.sightInfo[i].lat < min_lat)
          min_lat = this.sightInfo[i].lat;
        if (this.sightInfo[i].long > max_long)
          max_long = this.sightInfo[i].long;
        if (this.sightInfo[i].long < min_long)
          min_long = this.sightInfo[i].long;
      }

      if ((min_lat==0) || (min_long==0))
        return;

      this.loc_lat = (max_lat - min_lat)/2;
      this.loc_lat += parseFloat(min_lat);
      this.loc_long = ((max_long - min_long)/2);
      this.loc_long += parseFloat(min_long);


      //this.map_zoom = 12;     // norminal 14, larger=zoom in, smaller=zoom out
      let lat_diff = max_lat - min_lat;
      let long_diff = max_long - min_long;
      console.log("Diff Lat: "+lat_diff + "   Long: "+long_diff)

      if ((lat_diff>0.07) || (long_diff>0.07))
        this.map_zoom=14;
      else if ((lat_diff>0.06) || (long_diff>0.06))
        this.map_zoom=15;
      else if ((lat_diff>0.05) || (long_diff>0.05))
        this.map_zoom=16;
      else
        this.map_zoom=17;


      // todo
      // - add left right margin
      // - add 30% cutoff at right side
      console.log("Max Lat: "+max_lat + "   Long: "+max_long)
      console.log("Min Lat: "+min_lat + "   Long: "+min_long)
      console.log("New Lat: "+this.loc_lat + "   Long: "+this.loc_long + "   Zoom: "+this.map_zoom)


      this.map.panTo([this.loc_lat, this.loc_long],this.map_zoom);
    },













    // ********************************************************************************************
    // ***************************        WebSocket to Server      ********************************
    // ********************************************************************************************
    createBroadcast(){
      this.BroadClient = new w3cwebsocket(BroadcastUrl);

      this.BroadClient.onerror = (evt) => {
        console.log("Broadcast WebSocket Error : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };

      this.BroadClient.onopen = () => {
        console.log("Broadcast WebSocket Client Connected");

        // debug
        console.log("** Master List: " + this.sight_info)
        this.requestSight(0)
      };

      this.BroadClient.onclose = (evt) => {
        console.log("Broadcast WebSocket Closed : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };

      this.BroadClient.onmessage = (evt) => {
        this.BroadCallback(evt.data);
        //this.tcpCallback(evt.data);
      };
    },

    BroadcastSend(param) {
      this.BroadClient.send(param);
    },

    // - Mopi2 Command Start / Stop / Goto Next
    // - Cue
    BroadCallback(res) {
      console.log("Received from Server 8888: "+res);

      if (res.indexOf("{") > -1)
      {
        let data = JSON.parse(res);
        //console.log(data);
        // if receive command from somewhere -> route to engine
        if (data.type === 'Mopi2Start')
        {
          this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": 'AUTO'});
        }
        // if receive command from somewhere -> route to engine
        else if (data.type === 'Mopi2Stop')
        {
          this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": 'PAUSE'});
        }

        // Usually use to peek data
        else if (data.type === 'AutoDrivingCar')
        {
          this.veh_speed= data.speed.toFixed(0);
          //this.loc_lat= data.latitude;
          //this.loc_long= data.longitude;
          this.loc_heading= data.heading;

          //console.log("++++++++++++++++++++++++++++++++++++++++++");
          console.log("+++++ lat long heading speed: " + this.loc_lat.toFixed(5) +" " + this.loc_long.toFixed(5) +" " + this.loc_heading.toFixed(2) +" " + this.veh_speed);
          //console.log("+++++ Heading : " + this.loc_heading);
          //console.log("++++++++++++++++++++++++++++++++++++++++++");

          //this.chk_music_station()
          //this.drawRoute();
        }
        else if (data.type === 'RealTimeNavigation')
        {
          /*
          //当前站点信息
          this.currentPoint = 'You are now at Point ' + this.nextStationName;
          */
        }
        else if (data.type === 'HMIStatus')
        {
          //当前站点信息{"type":"HMIStatus","timestamp":1599494908454,"modes":0}
          if (data.modes === 2 || data.modes === 1 ||data.modes === "PAUSE") {    // 2=Pause, 1=Manual
            console.log("===== Manual =====");
            this.isStart = false;
          } else if (data.modes === 0 || data.modes === "AUTO") {                 // 0=Stop
            console.log("===== AUTO =====");
            this.isStart = true;
          } else {                                                                // any other => START
            this.isStart = false;
          }

          //this.chk_station()
          //this.drawRoute();
        }
        else if (data.type === 'eMobiRequestSight')
        {
          console.log("Total numbers: " + data.dataTotalNum);
          console.log(data.fields[0]);
          if (data.dataNum == 0)
          {
            this.hashtag1 = data.fields[0][3];
            this.hashtag2 = data.fields[0][4];
            this.hashtag3 = data.fields[0][5];
            this.hashtag4 = data.fields[0][6];
            this.hashtag5 = data.fields[0][7];
            this.hashtag6 = data.fields[0][8];

            this.sightInfoTotalNum = data.dataTotalNum
            this.sightInfoCurrentNum = data.dataNum+1
            this.clear_master_sight_list()
            this.requestSight(this.sightInfoCurrentNum)
          }
          else if (this.sightInfoCurrentNum == data.dataNum)
          {
            this.add_master_sight_list(data.fields[0])

            this.sightInfoCurrentNum = data.dataNum+1
            if (this.sightInfoCurrentNum >= this.sightInfoTotalNum)
            {
              this.refresh_list()
              console.log("** Master List: " + this.sight_info)
            }
            else
            {
              this.requestSight(this.sightInfoCurrentNum)
            }
          }
        }


      }
    },

    requestSight(sightIndex)
    {
      this.BroadcastSend(JSON.stringify({type: "eMobiRequestSight", index: sightIndex}));
    },



    // ********************************************************************************************
    // ***************************           Button Click          ********************************
    // ********************************************************************************************










































































    // ********************************************************************************************
    // ***************************                  OLD Code       ********************************
    // ********************************************************************************************


    //用于时间更新
    updateTime() {
      this.timer = setInterval(() => {
        this.time = moment().format("LT");
      }, 1000);
    },

    //路径以及标注数据适配
    formatRoutes(routes) {
      if (!routes) return;

      let points = [], //路径点
        markers = []; //标注点

      let startPosition = wgs84togcj02(
        routes.startPoint.longitude,
        routes.startPoint.latitude
      ).reverse();
      points.push(startPosition);

      if (routes.startPoint.isStation) {
        markers.push({
          lng: startPosition,
          id: routes.startPoint.stationId
        });
      }

      for (let point of routes.points) {
        let { latitude, longitude, isStation, stationId } = point;

        let position = wgs84togcj02(longitude, latitude).reverse();
        points.push(position);

        isStation &&
          markers.push({
            lng: position,
            id: stationId
          });
      }

      let endPosition = wgs84togcj02(
        routes.endPoint.longitude,
        routes.endPoint.latitude
      ).reverse();
      points.push(endPosition);

      if (routes.endPoint.isStation) {
        markers.push({
          lng: endPosition,
          id: routes.endPoint.stationId
        });
      }

      return {
        points,
        markers
      };
    },

    async drawRoutesAndMarkers(routes) {
      let { points, markers } = this.formatRoutes(routes);

      //根据坐标点画线路图
      this.drawRouter(points);

      //根据标注点画标注图
      //this.drawMarker(markers);
    },

    //根据坐标点位画路线
    drawRouter(points) {
      let polyline = this.L.polyline(points, {
        //color: "#bc4be5",
        color: "#13b49b",
        weight: 5
      }).addTo(this.map);

      this.map.fitBounds(polyline.getBounds());
    },







    //建立websocket连接
    createWSOri(url, looptTime) {
      let client = new w3cwebsocket(url);

      client.onerror = () => {
        console.error("Connection Error");
      };

      client.onclose = () => {
        this.reconnection(true);
        this.websocketConnecting =true;
        console.log("Client Closed");
      };

      return client;
    },





    //websocket处理函数
    processWS(url, looptTime = 100)
    {
      this.client = this.createWSOri(url, looptTime);

      this.client.onopen = () => {
        console.log("WebSocket Client Connected");
        this.websocketConnecting =false;
      };


      // Request simulation world every 100ms.
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestSimulationWorld();
        }
      }, 100);

      // Request RealTimeRoute every 1000ms.
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestRealTimeRoute();
        }
      }, 1000);




      // ----------------------------------------------
      // --------------- Socket Message ---------------
      // ----------------------------------------------
      this.client.onmessage = async ({ data }) => {
        if (data) {
          let message = null;
          try {
            message = JSON.parse(data);
          } catch (error) {
            console.warn(`Failed to parse string ${data}.`);
            return;
          }

          if (message.type === "RoutePath") {
            await this.drawRoutesAndMarkers(message);
          } else if (message.type === "AutoDrivingCar") {
            let {
              battery_level,
              gear_position,
              heading,
              latitude,
              longitude,
              speed,
              vehicle_status,
              steer_angle
            } = message;

            this.carInfo = {
              speed: speed ? speed.toFixed(0) : 0,
              batteryLevel: parseInt(battery_level * 100),
              gearPosition: gear_position.substr(0, 1)
            };

            if (heading && latitude && longitude) {
              let position = wgs84togcj02(longitude, latitude).reverse();

              if (this.marker) {
                this.updateCarPosition(position);
              } else {
                this.marker = this.drawCar(position);
              }
            }

            if (vehicle_status !== undefined) {
              this.isAuto = vehicle_status == 5 ? false : true;
              this.signSrc = sign[vehicle_status - 1];

              if (vehicle_status == 0) {
                this.signSrc = sign[4];
              }

              if (vehicle_status == 1) {
                this.turnSrc = left;
                this.isTurn = true;
              } else if (vehicle_status == 2) {
                this.turnSrc = right;
                this.isTurn = true;
              } else {
                this.isTurn = false;
              }
            }

            if (steer_angle) {
              this.rotate = steer_angle;
            } else {
              this.rotate = 0;
            }
          } else if (message.type === "SimulationWorld") {
            let { object } = message;

            Array.isArray(object) && (this.obstacles = object);
          } else if (message.type === "RealTimeNavigation") {
            let { next_station_name, next_station_timing } = message;

            this.station = {
              name: next_station_name,
              time: next_station_timing
            };
          } else if (message.type === "pong") {
            //心跳包
            this.client &&
              this.client.readyState === 1 &&
              this.client.send(
                JSON.stringify({
                  type: "ping"
                })
              );
          } else if (message.type === "HMIStatus") {
            let { current_mode } = message;

            if (current_mode == 0)
            {
              this.isAuto = true;
              this.isStart = true;
            } else if (current_mode == 1 || current_mode == 2)
            {
              this.isAuto = false;
              this.isStart = false;
            }
          } else if (message.type === "StationInfo") {
            this.visible = true;
            this.stationName = message.station_name;
            this.stationTime = message.station_timing;
            this.stationUrl = message.station_url;
          }
        }
      };
    },



    /*
    requestSimulationWorld() {
      this.client.send(
        JSON.stringify({
          type: "RequestSimulationWorld"
          //  planning : requestPlanningData,
        })
      );
    },
    requestRealTimeRoute() {
      this.client.send(
        JSON.stringify({
          type: "RequestRealTimeNavigation"
        })
      );
    },
    */



    //websocket心跳机制
    reconnection(flag = false) {
      if (flag) {
        if (this.reconnectionTimer) {
          return false;
        }

        this.reconnectionTimer = setTimeout(() => {
          console.log("reconnection!!!");

          if (this.map) {
            this.map.remove();
            this.map = null;
            this.marker = null;
          }

          this.initMap();
          this.processWS(WSURL);

          clearTimeout(this.reconnectionTimer);
          this.reconnectionTimer = null;
        //}, 5000);
        }, 1000000);    // Patrick debug
      }
    },

    //临时停车
    tempHandler() {
      this.isTempStart = !this.isTempStart;
      this.tempSrc = this.isTempStart ? stop : start;

      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: this.isTempStart ? "PAUSE" : "RESUME"
          })
        );
    },

    //去往目的地
    gotoDest() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            //TODO 去往选定的目的地
          })
        );
    },



    //自动、手动切换
    // ---------------------------------------------------
    // --------------- START / STOP Button ---------------
    // ---------------------------------------------------
    operate() {

      this.isStart = !this.isStart;

      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: this.isStart ? "AUTO" : "PAUSE"
          })
        );
    },


    //缓存log日志
    cacheLog() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            enable_log: true
          })
        );
    },

    //紧急电话
    callPhone() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            enable_phone_call: true
          })
        );
    },
    //module reboot
    moduleStart() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: "MODULE_START"
          })
        );
    },
    //关机
    shutDown() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: "POWEROFF"
          })
        );
    }
  },





  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }



};

</script>





















<style scoped>




.main-wrapper_class {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}


.map_class {
  display: flex;
  background-color: rgba(29, 0, 65, 1);
  text-align: justify;
  width: 70%;
  height: 100%;

  border: 0;
  justify-content: left;
  margin-left: 0px;
  margin-right: 0px;
}

.home_logo_long_class {
  width: 100px;
  height: 35px;
  display: flex;
  justify-content: left;
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px;
  z-index: 1000;
}

.home_logo_class {
  width: 70px;
  height: 35px;
  display: flex;
  justify-content: left;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
  z-index: 1000;
}

.home_search_class {
  height: 35px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-left: auto;
  margin-right: 20px;
  margin-top: 20px;
  z-index: 1000;
}


.content_class {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  text-align: justify;
  width: 30%;
  height: 100%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;
}

.title_class {
  display: flex;
  flex-direction: row;
  width: 50%;
  height: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 25%;

  border-radius:20px;
  font-size:25px;
  font-weight: bold;
  background-color: #13b49b;
  color: #fff;
  border: none;

  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
}


.detail_class {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  text-align: justify;
  width: 100%;
  height: 100%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;
}

.detail_header_class {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  text-align: justify;
  width: 100%;
  height: 10%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;
}

.detail_header_icon_class{
  width: 40px;
  height: 40px;
  margin-top: 5px;
}

.detail_header_text_class{
  width: 80%;
  height: 100%;
  font-size: 25px;
  font-weight: bold;
  text-align: justify;
  margin-left: 10px;
}



.detail_content_class {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  text-align: justify;
  width: 80%;
  height: 80%;
  margin-left: 50px;
}

.detail_header_photo_class{
  width: 100px;
  height: 100px;
  margin-top: 5px;
}

.detail_content_row_class {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  margin-top: 20px;
}

.detail_content_row_subject_class{
  font-size: 15px;
  font-weight: bold;
  text-align: justify;
}
.detail_content_row_text_class{
  font-size: 15px;
  text-align: justify;
  margin-left: 10px;
}

.detail_content_subject_class{
  font-size: 15px;
  font-weight: bold;
  text-align: justify;
  margin-top: 20px;
}
.detail_content_text_class{
  font-size: 15px;
  text-align: justify;
}

.detail_content_hashtag_class{
  margin-top: 20px;
  font-size: 15px;
  text-align: justify;
}


.detail_bottom_class {
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  text-align: justify;
  width: 100%;
  height: 10%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;
}

.detail_button_class {
  width: 100px;
  height: 40px;
  margin-left: 10px;
  margin-right: 10px;
}


.table_class {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  border: 0;
  justify-content: center;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 0px;
  font-size: 15px;
}

.hashtag_table_class {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  border: 0;
  justify-content: center;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 0px;
  font-size: 15px;
}


table {
  border-collapse: collapse;
  width: 100%;
}
tbody {
  display: block;
  overflow:scroll;
  height: 100%;
}
tbody tr {
  display: table;
  width: 100%;
  height: 90px;
  table-layout: fixed;
  word-break: break-all;
  border-bottom: 1pt solid grey;
}

.table_icon_class {
  width: 20%;
}
.table_content_class {
  width: 60%;
}
.table_sales_class {
  width: 20%;
}

table tbody::-webkit-scrollbar {
  width: 6px;
}
table tbody::-webkit-scrollbar-thumb {
  background-color: #01f5f1;
  border-radius: 5px;
}
table tbody::-webkit-scrollbar-track {
  /*background-color: #004453;*/
  background-color: #ffffff;
}
table tbody::-webkit-scrollbar-thumb:hover {
  background-color: rgb(17, 177, 174);
}
table tbody::-webkit-scrollbar-thumb:active {
  background-color: rgb(9, 136, 134);
}











.TableMain_class {
  /*background: linear-gradient(to bottom, #f8f9fc 0%, #f2f7f9 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.2);*/
  z-index: 999;
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;

  height: 100%;
  width: 20%;
  padding: 0px;
}






























/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------        Index     -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.index-container {
  /* */
  display: flex;
  height: 100%;
  width: 100%;

  background: #fff;
  position: relative;
  font-size: 60px;
}
.index {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
}
.index-logo{
  width: 81px;
  height: 134px;
  margin-bottom: -20px;
}
.index-txt{
  padding-left: 20px;
}

.mainlogo{
  width: 195px;
  height: 67px;
  position:fixed;
  bottom:50px;
  left:50%;
  margin-left: -100px;
}



/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------  User Selection  -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.mainPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 75%;
  height: 100%;
}


.mainPanelCenterContent{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 90%;
  height: 100%;
}



.haveOrder {
  display: flex;
  flex-direction: column;
  flex-wrap:wrap-reverse;
  background-color: white;
  margin-left: auto;
  align-items: center;
  align-content: center;
  width: 25%;
  height: 100%;
}

.yesBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #13b49b;
}

.noBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #C7CCD5;
}

.stationButtonOdd
{
  font-size:35px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #13b49b;
}
.stationButtonEven
{
  font-size:35px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #C7CCD5;
}





/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------       Map        -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
















.main {
  background: linear-gradient(to bottom, #f8f9fc 0%, #f2f7f9 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.2);
  z-index: 999;
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 20px;
  margin-left: 30px;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: right;
}

.time {
  font-weight: 400;
  color: rgba(29, 38, 65, 1);
}

.sign {
  /*
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
   */
  display: flex;
  margin-right: 2%;
}


.speed_block{
  /*
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  display: inline-block;
  position: relative;
}

.speed {
  /*
  width: 50%;
  left: 0%;
  right: 0%;
  text-align: center;
  position: absolute;
  font-weight: bold;
  color: rgba(29, 38, 65, 1);
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  position: absolute;
  text-align: center;
  left: 0%;
  right: 0%;
}
.unit {
/*
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex: 1;
  display: flex;
*/
  position: absolute;
  text-align: right;
  vertical-align: text-bottom;
  top: 30px;
  right: 2%;
}
.line {
  height: 3px;
  width: 100%;
  background: rgba(0, 0, 0, 1);
}


.body {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.stop_logo {
  display: flex;
}
.stopsign_logo {
  display: flex;
}
.car_logo {
  display: flex;
}

.station_block{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.next_station {
  display: flex;
  text-align: center;
}
.station_name {
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_1{
  display: flex;
  text-align: center;
}
.stop_sign_2{
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_3{
  display: flex;
  text-align: center;
}

.footer {
  display: flex;
  position: absolute;
}
.start {
  flex: 1;
  /* box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16); */
  color: #fff;
  border: none;
}



.info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #484848;
  position: relative;
}

.electricity {
  height: 20px;
  width: 100px;
}

.split {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}


.block {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.wheel {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.drive {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px;
}

.mask {
  height: 100%;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.canvas {
  height: 100%;
  width: 100%;
}

.msg {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}

.station,
.duration {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.key {
  font-weight: 400;
  color: rgba(128, 132, 143, 1);
  white-space: nowrap;
}

.value {
  font-weight: 400;
  line-height: 49px;
  color: rgba(28, 28, 28, 1);
}

.temp {
  padding: 20px;
  background: rgba(255, 177, 0, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: none;
  margin-right: 10px;
}



@media screen and (min-width: 2048px) {
  .main {
    width: 660px;
    padding: 48px;

    position: absolute;
    margin-top: 50px;
    margin-left: 50px;
    margin-bottom: 50px;

  }

  .time {
    font-size: 44px;
    line-height: 82px;
  }

  .sign {
    height: 120px;
    width: 110px;
  }

  .speed_block {
    height: 250px;
  }

  .speed {
    font-size: 200px;
    line-height: 200px;
  }

  .unit {
    font-size: 30px;
    line-height: 250px;
  }

  .stop_logo {
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    height: 118px;
    width: 114px;
  }
  .next_station {
    font-size: 30px;
    line-height: 100px;
  }
  .station_name {
    font-size: 40px;
    line-height: 150px;
  }
  .stop_sign_1{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_2{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_3{
    font-size: 30px;
    line-height: 100px;
  }

  .footer{
    width: 240px;
    height: 60px;
    line-height: 60px;
  }
  .start {
    height: 88px;
    font-size: 38px;
    /* border-radius: 88px; */
    border-radius: 0px;
  }



  .block {
    top: -28px;
  }
  .drive {
    height: 600px;
  }

  .key {
    font-size: 28px;
    line-height: 82px;
  }

  .value {
    font-size: 40px;
    line-height: 49px;
  }

  .temp {
    width: 88px;
    height: 88px;
    border-radius: 88px;
  }


}

@media screen and (max-width: 1920px) {
  .main {
    width: 300px;
    height: 95%;
    padding: 30px;
  }


  .speed_block {
    height: 100px;
  }
  .speed {
    font-size: 100px;
    line-height: 100px;
  }
  .unit {
    font-size: 20px;
    line-height: 100px;
  }


  .stop_logo {
    margin-top: 5%;
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    margin-bottom: 10%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    margin-top: 10%;
    height: 124px;
    width: 202px;
  }
  .next_station {
    margin-top: 5%;
    font-size: 20px;
    line-height: 20px;
  }
  .station_name {
    margin-top: 10%;
    font-size: 25px;
    line-height: 25px;
  }
  .stop_sign_1{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_2{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_3{
    font-size: 25px;
    line-height: 30px;
  }


  .footer{
    width: 240px;
    height: 50px;
    line-height: 60px;
    bottom: 5%;
  }
  .start {
    width: 240px;
    height: 50px;
    font-size: 30px;
    /* border-radius: 68px; */
    border-radius: 0px;
  }









  .time {
    font-size: 35px;
    line-height: 64px;
  }

  .sign {
    height: 43px;
    width: 43px;
  }

  .block {
    top: -28px;
  }

  .drive {
    height: 520px;
  }

  .key {
    font-size: 22px;
    line-height: 64px;
  }

  .value {
    font-size: 32px;
    line-height: 30px;
  }

  .temp {
    width: 68px;
    height: 68px;
    border-radius: 68px;
  }

}

picture {
  display: flex;
  align-items: center;
  justify-content: center;
}






.log,
.phone,
.close {
  position: absolute;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  border-radius: 44px 0px 0px 44px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}


.logo {
  top: 20px;
  right: 0;
  width: 220px;
}



.log {
  height: 100px;
  width: 100px;
  bottom: 280px;
  right: 38px;
  border-radius: 50%;
}

.phone {
  height: 100px;
  width: 100px;
  bottom: 160px;
  right: 38px;
  border-radius: 50%;
}

.close {
  height: 100px;
  width: 100px;
  bottom: 40px;
  right: 38px;
  border-radius: 50%;
}

.shut {
  height: 80px;
  font-family: PingFang-SC-Bold;
  font-size: 40px;
  color: #1c1c1c;
  text-align: center;
  line-height: 40px;
}
</style>






<!--
    --------------------------------------------------------------------------------------------------------------
    --------------------------------------------------------------------------------------------------------------
    --------------------------------------          Recycle Code            --------------------------------------
    --------------------------------------------------------------------------------------------------------------
    --------------------------------------------------------------------------------------------------------------

    toggleDir() {
      this.isGo = !this.isGo;
      //this.route_point+=50;
      //this.loc_lat = 35.1628012;
      //this.loc_long = 137.8680675;
      //this.isStop = !this.isStop;

      //this.chk_station()
      this.drawRoute();
    },


    // ***************************************************************************************************
    // **************************    Check whether it stop at proper station    **************************
    // ***************************************************************************************************
    chk_station(){
      let location=[this.loc_lat, this.loc_long];
      let point_checked= false;

      // ----- if Stopped, chk within station range or StopSign range -----
      // ----- update isGo, isStop, route_point, current_station_name, next_station_name
      if (!this.isStart)
      {
        if (this.chk_point(station[0], location, this.station_margin)){   // station 0 -> go up
          this.isGo=false;     // mean go up next
          this.isStop=false;
          this.route_point=station_point[0];
          this.current_station_name=station_name[0];
          this.next_station_name=station_name[1];
          point_checked=true;
        } else if (this.chk_point(station[1], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[1];
          this.current_station_name=station_name[1];
          if (this.isGo)
            this.next_station_name=station_name[0];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[2], location, this.station_margin)){
          this.isGo=true;     // will go down next
          this.isStop=false;
          this.route_point=station_point[2];
          this.current_station_name=station_name[2];    // in top
          this.next_station_name=station_name[1];
          point_checked=true;
        }
        /*
        else if (this.chk_point(station[3], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[3];
          this.current_station_name=station_name[3];
          if (this.isGo)
            this.next_station_name=station_name[4];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[4], location, this.station_margin)){
          this.isGo=false;     // must go back
          this.isStop=false;
          this.route_point=station_point[4];
          this.current_station_name=station_name[4];
          this.next_station_name=station_name[3];
          point_checked=true;
        } else if (this.chk_point(stop_pos, location, this.station_margin)){
          this.isStop=true;
          this.route_point=58;
          if (this.isGo) {
            this.current_station_name = station_name[0];
            this.next_station_name = station_name[1];
          }
          else{
            this.current_station_name=station_name[1];
            this.next_station_name=station_name[0];
          }
          point_checked=true;
        }
        */
      }

      // ----- if Running, chk within point range -----
      // ----- update route_point
      if (point_checked==false)
      {
         let i;
         for (i=0;i<route.length;i++){
           if (this.chk_point(route[i],location, this.station_margin)) {
             this.route_point = i;
             this.isStop = false;
             i = 1000;
           }
         }

         //if (i==1001)   // route point updated
         if (i==9999)     // disabled - never use
         {
           let point_margin;

           // Station 0<->1
           point_margin=(station_point[1]-station_point[0])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[0]+point_margin)) && (this.route_point<(station_point[1]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[0];
               this.next_station_name   =station_name[1];
             } else {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[0];
             }
           }

           // Station 1<->2
           point_margin=(station_point[2]-station_point[1])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[1]+point_margin)) && (this.route_point<(station_point[2]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[2];
             } else {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[1];
             }
           }
           /*
           // Station 2<->3
           point_margin=(station_point[3]-station_point[2])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[2]+point_margin)) && (this.route_point<(station_point[3]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[3];
             } else {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[2];
             }
           }
           // Station 3<->4
           point_margin=(station_point[4]-station_point[3])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[3]+point_margin)) && (this.route_point<(station_point[4]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[4];
             } else {
               this.current_station_name=station_name[4];
               this.next_station_name   =station_name[3];
             }
           }
           */

         }


      }
      console.log("**********");
      console.log("***** Route Point : " + this.route_point);
      console.log("**********");
    },


    chk_point(point, loc, margin)   // point=current    loc=target point
    {
      //console.log("????? Margin : " + margin);
      //console.log("????? Check Point : " + point[0] +" " +point[1]);
      //console.log("????? Loc   Point : " + loc[0] +" " +loc[1]);

      if (loc[0]>(point[0]+margin) || loc[0]<(point[0]-margin)){
        console.log("----- CHk Point False");
        return false;
      }
      if (loc[1]>(point[1]+margin) || loc[1]<(point[1]-margin)){
        console.log("----- CHk Point False");
        return false;
      }


      console.log("----- CHk Point Pass");
      return true;
    },



    chk_music_station()
    {
      let i;
      let location=[this.loc_lat, this.loc_long];

      console.log(this.sound1_played + "  " + this.sound2_played + "  " + this.sound3_played + "  " + this.sound4_played + "  " + this.sound5_played + "  ");

      if (this.chk_point(location, route[this.music_station[0]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[0], this.target_heading_upper[0]))
      {
        console.log("----- Sound Reset -----");
        this.sound1_played=false;
        this.sound2_played=false;
        this.sound3_played=false;
        this.sound4_played=false;
        this.sound5_played=false;
      }
      else if (this.chk_point(location, route[this.music_station[1]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[1], this.target_heading_upper[1]))
      {
        console.log("----- CHk Music 1 PASS -----");
        if (this.sound1_played==false)
        {
          this.playSound(1);
          this.sound1_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[2]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[2], this.target_heading_upper[2]))
      {
        console.log("----- CHk Music 2 PASS -----");
        if (this.sound2_played==false)
        {
          this.playSound(2);
          this.sound2_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[3]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[3], this.target_heading_upper[3]))
      {
        console.log("----- CHk Music 3 PASS -----");
        if (this.sound3_played==false)
        {
          this.playSound(3);
          this.sound3_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[4]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[4], this.target_heading_upper[4]))
      {
        console.log("----- CHk Music 4 PASS -----");
        if (this.sound4_played==false)
        {
          this.playSound(4);
          this.sound4_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[5]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[5], this.target_heading_upper[5]))
      {
        console.log("----- CHk Music 5 PASS -----");
        if (this.sound5_played==false)
        {
          this.playSound(5);
          this.sound5_played=true;
        }
      }


    },


    chk_heading(current_heading, target_heading_lower, target_heading_upper)
    {
      //console.log("????? Heading Current Target : " + current_heading +" " + target_heading);

      // just for small angle
      if ((target_heading_upper<40) && ((current_heading>target_heading_lower) || (current_heading<target_heading_upper)))
      {
        console.log("----- CHk Heading Pass");
        return true;
      }
      else if ((current_heading>target_heading_lower) && (current_heading<target_heading_upper))
      {
        console.log("----- CHk Heading Pass");
        return true;
      }


      console.log("----- CHk Heading False");
      return false;
    },

    playSound(soundNo)
    {
      this.$refs.audio1.pause();
      this.$refs.audio2.pause();
      this.$refs.audio3.pause();
      this.$refs.audio4.pause();
      this.$refs.audio5.pause();


      if (soundNo==1)
      {
        this.$refs.audio1.currentTime = 0;
        this.$refs.audio1.play();
      }
      else if (soundNo==2)
      {
        this.$refs.audio2.currentTime = 0;
        this.$refs.audio2.play();
      }
      else if (soundNo==3)
      {
        this.$refs.audio3.currentTime = 0;
        this.$refs.audio3.play();
      }
      else if (soundNo==4)
      {
        this.$refs.audio4.currentTime = 0;
        this.$refs.audio4.play();
      }
      else if (soundNo==5)
      {
        this.$refs.audio5.currentTime = 0;
        this.$refs.audio5.play();
      }

      console.log("----- Play Sound " + soundNo + "  -----");

    },




    indexClick()
    {
      console.log(" ##### cueSize= "+ this.cueSize);

      //if (this.cueSize>0) {
      //  this.systemState=1; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running
      //  this.userNameString = this.objcue[0].username + "樣ですか?";
      //}
      //else
      {
        this.systemState=2; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running
        //this.initMap();
        this.$nextTick(() => {
          if (this.map) {
            this.map.remove();
            this.map = null;
            this.marker = null;
          }
          this.initMap();
        });
      }
    },

    clickBtnNameYes()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },

    clickBtnNameNo()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },


    // ----- 点击开始/结束按钮 -----
    clickBtn() {
      //先根据指令停车开车
      this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": this.isStart ? 'PAUSE' : 'AUTO'});

      if (this.isStart) {
        //this.playSound(1);
        this.isStart = false;
      }
      else {
        //this.playSound(2);
        this.isStart = true;
      }
      //this.isStart = !this.isStart;

      /*
      if (!this.isArrivedNext) {
        this.isPoint = true;
        this.currentPoint = 'You are now moving to Point ' + this.nextStationName;
      } else {
        this.isPoint = false;
        this.currentPoint = 'You are now at Point ' + this.nextStationName;
      }
      */
    },



0) Change to smaller screen
1) Enlarge ballon when highlight
1) Facorite ballow larger
2) display icon in detail page
3) IG - show IG content in detail page
4) change to deep green ballon
5) Tuktuk update to center of car
6) https
7) Favourite
8) Others -> parking

9) change heading direction



-->
